import React from 'react'
import moment from 'moment'
import { connect } from 'react-redux'
import './index.scss'

// eslint-disable-next-line camelcase
const ConversationHeader = ({
    data = {},
    statuses,
    statusOn: {
        statusOn: { showStatus },
    },
}) => {
    const renderStatus = () => {
        // eslint-disable-next-line camelcase
        if (showStatus && statuses && statuses.length > 0) {
            return (
                <div className='status_wrapper'>
                    <p className='status_status'>
                        Status: {statuses[statuses.length - 1].Status}
                    </p>
                    <p className='status_time'>
                        Last updated:
                        {moment
                            .unix(statuses[statuses.length - 1].ts / 1000)
                            .format('DD MMM hh:mm A')}
                    </p>
                </div>
            )
        }
    }
    console.log({ data })
    return (
        <div className='ConversationHeader'>
            <p className='ConversationHeader__user'>
                {data.Blacklisted ? (
                    <span>A Customer</span>
                ) : (
                    <>
                        <span>{data.Name}</span> <span>{data.Surname}</span>
                    </>
                )}
            </p>
            <p className='ConversationHeader__vin'>{data.Vin}</p>
            {renderStatus()}
        </div>
    )
}

const mapStateToProps = state => {
    const { statuses, statusOn } = state.conversationPanel
    return {
        statuses,
        statusOn,
    }
}

export default connect(mapStateToProps, {})(ConversationHeader)
